module.exports = __webpack_public_path__ + "img/whitepaper.9d9d798c.png";